export const defaultSources = ['ownData'];

export const initializeData = (data) => {
  const items = [];

  const addItem = (item, level, parent, isOwnData) => {
    const sources = item.sources;
    let targets = [];

    if (parent) {
      targets = [parent];
    } else {
      targets = item.children ? item.children.map((ch) => ch.id) : [];
    }
    items.push({
      type: item.type,
      id: item.id,
      label: item.name,
      title: item.title,
      datastakeId: item.datastakeId,
      namespace: item.namespace,
      sources,
      targets,
      level,
      isOwnData,
      otherSources: item.otherSources,
      isNotConnected: item.isNotConnected,
    });
  }

  const addChildren = (children, level, parent) => {
    children.forEach((child) => {
      addItem(child, level, parent);
      if (child.children) {
        addChildren(child.children, level + 1);
      }

      if (child.parents) {
        addChildren(child.parents, level - 1, child.id);
      }
    });
  };

  // const ownDataIsValid = checkIfIsValid(data.sources);

  // if (ownDataIsValid) {

  addItem(data, 0, undefined, true);

  if (data.children) {
    addChildren(data.children, 1);
  }

  if (data.parents) {
    addChildren(data.parents, -1, data.id);
  }

  const levels = items.map((i) => i.level);
  const min = Math.min(...levels);
  const max = Math.max(...levels);

  const sections = [];
  for (let i = min; i <= max; i++) {
    const section = items.filter((it) => it.level === i);
    sections.push(section);
  }

  return sections;
  // }
  // return [];
};

export const sourcesColors = {
  ownData: '#2E90FA',
  supplyChainActors: '#52C41A',
  informationSources: '#FF7875',
};

export const isSource = (id, con) => {
  const sourceCon = con.find((c) => c.source === id);
  if (sourceCon) {
    return true;
  }
  return false;
};

export const isTarget = (id, con) => {
  const targetCon = con.find((c) => c.target === id);
  if (targetCon) {
    return true;
  }
  return false;
};
